import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => {
    return (
        <Spinner
            as="span"
            animation="border"
            size="md"
            role="status"
            aria-hidden="true"
            color="white"
            className="ms-2"
        />
    );
};

export default Loader;
